<div class="flex flex-col gap-8 items-center mt-16">
  <mat-icon [size]="100" color="var(--p-neutral-700)">computer_cancel</mat-icon>
  <div class="text-center text-3xl w-full">
    {{ 'general.pageNotFound' | translate }}
  </div>
  <p-button [outlined]="true" [label]="'general.home' | translate" routerLink="/" />
</div>
